import * as React from "react";
import { Box, Grid } from "@mui/material";
import DataKPIPanel from "../../components/dashboard/kpi/DataKPIPanel";
import UsageMapPanel from "../../components/dashboard/usage-map/UsageMapPanel";
import RankingPanel from "../../components/dashboard/ranking/RankingPanel";
import PlayActivityPanel from "../../components/dashboard/activity/PlayActivityPanel";
import Footer from "../../layout/home/footer";

export default function DashboardView() {
    return (
        <Box sx={{ height: "100vh", width: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <Grid container sx={{ flex: 1, height: "100%" }}>
                {/* Left Column: KPI Panel + Usage Map Panel */}
                <Grid item xs={7} sx={{ display: "flex", flexDirection: "column", height: "100%", borderRight: "3px solid #000" }}>
                    {/* KPI Panel - narrow top strip */}
                    <Box sx={{ flex: "0 0 auto", borderBottom: "3px solid #000" }}>
                        <DataKPIPanel />
                    </Box>
                    {/* Usage Map Panel - fills remaining left space */}
                    <Box sx={{ flex: 1, overflow: "hidden" }}>
                        <UsageMapPanel />
                    </Box>
                </Grid>

                {/* Right Column: Ranking Panel + Play Activity Panel */}
                <Grid item xs={5} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    {/* Ranking Panel - top half */}
                    <Box sx={{ flex: 2, borderBottom: "3px solid #000", overflow: "hidden" }}>
                        <RankingPanel />
                    </Box>
                    {/* Play Activity Panel - bottom half */}
                    <Box sx={{ flex: 1, overflow: "hidden" }}>
                        <PlayActivityPanel />
                    </Box>
                </Grid>
            </Grid>
            <Footer />
        </Box>
    );
}
